module.exports = __webpack_public_path__ + "img/dialog-idCard.b99e80c4.png";